import { format, getTime, formatDistanceToNow } from 'date-fns';

// ----------------------------------------------------------------------

function fDate(date: Date | string | number) {
  return format(new Date(date), 'dd MMMM yyyy');
}

function fDateTime(date: Date | string | number) {
  return format(new Date(date), 'dd MMM yyyy p');
}

function fTimestamp(date: Date | string | number) {
  return getTime(new Date(date));
}

function fDateTimeSuffix(date: Date | string | number) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm p');
}

export function fToNow(date: Date | string | number) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true,
  });
}

export function getCorrectLang() {
  switch (navigator.language.split('-').length) {
    case 0:
      return 'en';
    default:
      return navigator.language.split('-')[0]
  }
}